import { createSlice } from '@reduxjs/toolkit';
import { createRestSlice } from 'utils/RestSlice';

import BuyerLoanOfficersRepository from 'repositories/public/buyer/LoanOfficersRepository';

const restSlice = createRestSlice({
  resource: 'loanOfficer',
  pluralResource: 'loanOfficers',
  repository: BuyerLoanOfficersRepository,
  slices: ['loadLoanOfficers', 'loadMoreLoanOfficers'],
});

const initialState = {
  ...restSlice.initialState,
};

const publicBuyerLoanOfficersSlice = createSlice({
  name: 'publicBuyerLoanOfficers',
  initialState,
  reducers: {
    ...restSlice.reducers,
  },
});

export default publicBuyerLoanOfficersSlice;
export const publicBuyerLoanOfficersReducer = publicBuyerLoanOfficersSlice.reducer;
export const publicBuyerLoanOfficersHooks = restSlice.hooks(
  publicBuyerLoanOfficersSlice,
  'publicBuyerLoanOfficersReducer',
);



// WEBPACK FOOTER //
// ./src/reducers/slices/public/buyer/loanOfficersSlice.js